// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__xNLzq","footer":"ModalCreateQualiphyProcedure_footer__3W6IT","additionData":"ModalCreateQualiphyProcedure_additionData__1LHHo"};